export class GitProvidersOrganization {
    constructor(model) {
        this.id = model.id;
        this.name = model.name;
        this.url = model.url;
        this.slug = model.slug;
    }
}
export class GitProvidersOrganizations {
    constructor(model) {
        this.organizations = model.organizations.map((organization) => new GitProvidersOrganization(organization));
    }
}
